import { createFileRoute } from '@tanstack/react-router'
import AuthScreen from './-components'

export const Route = createFileRoute('/(auth)/reset-password/')({
  component: () => <AuthScreen />
})